export const fadeInAction = () => {
  $(function () {
    // フワッと表示
    // inViewのプラグインを使用
    $(".js-scroll-show").on("inview", function () {
      $(this).addClass("is-show");
    });
  });
};
